import store from '@/store'

/**
 * Vérifie si l'utilisateur à le role
 * @param role
 * @returns {*|string}
 */
export const hasRole = (role) => store.state.user.utilisateur[role]

/**
 * Vérifie si l'utilisateur bénéficie au moins d'un des rôles listé
 * En cas d'altersession, seul le profil altéré est comparé
 * @param aRoles
 * @returns {Boolean}
 */
export const isGrantedRole = (aRoles) => store.state.user.alteredProfile
  ? aRoles.some(k => k === store.state.user.alteredProfile) || aRoles.some(hasRole)
  : aRoles.some(hasRole)

/**
 * Vérifie si l'utilisateur peut accéder à une router
 * @param r
 * @returns {boolean}
 */
export const isGrantedRoute = ({ meta }) => {
  if (!store.getters['user/hasValidSubscription']) {
    return false
  }
  if (!meta || !(meta.roles || meta.hasRole || meta.isGranted)) {
    return true
  }
  if (meta.isGranted &&
    !(
      (typeof meta.isGranted === 'function' && meta.isGranted()) ||
      store.getters['user/isGranted'](meta.isGranted)
    )) {
    return false
  }
  if (meta.hasRole && !hasRole(meta.hasRole)) {
    return false
  }
  return meta.roles
    ? isGrantedRole(meta.roles)
    : true
}
